import { render } from "./ItemTile.vue?vue&type=template&id=17333222&scoped=true"
import script from "./ItemTile.vue?vue&type=script&lang=js"
export * from "./ItemTile.vue?vue&type=script&lang=js"

import "./ItemTile.vue?vue&type=style&index=0&id=17333222&scoped=true&lang=css"

import exportComponent from "/media/dev/Develop/Projects/Sjef/kiosk.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17333222"]])

export default __exports__